// extracted by mini-css-extract-plugin
export default {"loading":"styles_loading__Ncz+h"};